import script from "./BillPayTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./BillPayTableRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__